import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { SingleScannerComponent } from "../single-scanner/single-scanner.component";

@Component({
    selector: 'textbox-camera',
    templateUrl: './textbox-camera.component.html',
    styleUrls: ['./textbox-camera.component.scss'],
    host: {
        class: 'textbox-camera'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class TextboxCameraComponent implements OnInit {

    @Output() qrCodeScanned = new EventEmitter<string>();

    @Input()
    disabled: boolean = false;

    data: any;
    isCameraScannerVisible: boolean = false;
    @ViewChild(SingleScannerComponent) cameraScannerComponent?: SingleScannerComponent;

    constructor(private confirmationService: ConfirmationService) {
    }

    ngOnInit(): void {}

    openCameraScanner() {
        this.isCameraScannerVisible = true;
        this.data = null;
        this.confirmationService.confirm({
                key: 'camera-dialog',
                header: ''
                });
    }

    closeCameraScanner() {
        this.cameraScannerComponent?.closeScanner();
        this.onScannerClosed();
    }

    onQRCodeScanned(qrCode: any) {
        this.data = qrCode;
        this.onScannerClosed();
    }

    onScannerClosed() {
        this.isCameraScannerVisible = false;
        this.confirmationService.close();
        if (this.data) {
            this.qrCodeScanned.emit(this.data);
        }
    }
}
